/**
 * recentsStore.js — ELYON-SHELL-FOUNDATION-1
 *
 * Zustand store tracking recently visited routes.
 * Max 10 entries. 30-day TTL. Persisted to localStorage.
 *
 * Ported from elyon-app/src/stores/recentsStore.ts — adapted to plain JS.
 *
 * RecentEntity shape:
 *   { entityId, entityType, title, breadcrumb, route, visitedAt }
 */
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const MAX_RECENTS = 10;
const TTL_MS = 30 * 24 * 60 * 60 * 1000; // 30 days

export const useRecentsStore = create(
  persist(
    (set) => ({
      recents: [],

      addRecent: (entity) =>
        set((s) => {
          const now = new Date().toISOString();
          // Remove existing entry for same entity (dedup)
          const filtered = s.recents.filter(
            (r) => !(r.entityId === entity.entityId && r.entityType === entity.entityType)
          );
          return {
            recents: [{ ...entity, visitedAt: now }, ...filtered].slice(0, MAX_RECENTS),
          };
        }),

      clearRecents: () => set({ recents: [] }),

      pruneExpired: () =>
        set((s) => ({
          recents: s.recents.filter(
            (r) => Date.now() - new Date(r.visitedAt).getTime() < TTL_MS
          ),
        })),
    }),
    {
      name: 'elyon_recents',
      partialize: (s) => ({ recents: s.recents }),
    }
  )
);

/** Primitive selector — avoids object-spread closure re-renders. */
export const useRecents = () => useRecentsStore((s) => s.recents);
